import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import styled from '@emotion/styled';
import { useThemeWithPartner } from 'components/common/ThemeConfigProvider';
import { deleteCookie, getCookie, setCookie } from 'cookies-next';
import useAuth from 'hooks/useAuth';
import { useFetcher } from 'hooks/useFetcher';

function SidebarInfo() {
    const { t } = useTranslation();
    const theme = useThemeWithPartner();
    const [consent, setConsent] = useState(true);
    const { auth, profile } = useAuth();
    const { POST } = useFetcher();
    const acceptCookie = () => {
        if (auth.isAuth) saveCookieConsent(1);

        if (process.env.NODE_ENV === 'production') {
            setCookie('localConsent', 'true', { maxAge: 60 * 60 * 24 * 365, domain: 'pharmcare.co', sameSite: 'none', secure: true });
        } else {
            setCookie('localConsent', 'true', { maxAge: 60 * 60 * 24 * 365 });
        }
        console.log('accepring cookies');

        window.location.reload();
    };

    const denyCookie = () => {
        window[`ga-disable-${process.env.REACT_APP_GOOGLE_ANALYTICS_GTAG_KEY}`] = true;
        if (auth.isAuth) saveCookieConsent(0);

        if (process.env.NODE_ENV === 'production') {
            setCookie('localConsent', 'false', { maxAge: 60 * 60 * 24 * 365, domain: 'pharmcare.co', sameSite: 'none', secure: true });
        } else {
            setCookie('localConsent', 'false', { maxAge: 60 * 60 * 24 * 365 });
        }

        deleteCookie('_fbp', { domain: process.env.REACT_APP_DOMAIN_YAPHROM });
        deleteCookie('_fbp', { domain: process.env.REACT_APP_DOMAIN });
        deleteCookie('_fbp', { domain: 'pharmcare.co' });
        deleteCookie('_ga', { domain: process.env.REACT_APP_DOMAIN_YAPHROM });
        deleteCookie('_ga', { domain: process.env.REACT_APP_DOMAIN });
        deleteCookie('_ga', { domain: 'pharmcare.co' });

        Object.keys(
            document.cookie.split(';').reduce((acc, c) => {
                const [key] = c.trim().split('=');
                if (key.startsWith('_ga_')) acc[key] = true;
                return acc;
            }, {})
        ).forEach((key) => {
            deleteCookie(key, { domain: process.env.REACT_APP_DOMAIN_YAPHROM });
            deleteCookie(key, { domain: process.env.REACT_APP_DOMAIN });
            deleteCookie(key, { domain: 'pharmcare.co' });
        });
        console.log('denying cookie');
        window.location.reload();
    };

    const saveCookieConsent = async (cookieConsent = 0) => {
        try {
            await POST('/user/save-cookie-consent', { userId: profile.userId, cookieConsent: cookieConsent });
        } catch (error) {
            console.error('/user/save-cookie-consent -> error', error);
        }
    };
    const onChange = async (event) => {
        if (event.target.checked) {
            await acceptCookie();
        } else {
            await denyCookie();
        }
        setConsent(event.target.checked);
    };

    useEffect(() => {
        const checkProfileWithConsent = async () => {
            const consent = getCookie('localConsent', { domain: process.env.REACT_APP_DOMAIN });
            setConsent(consent);
        };

        checkProfileWithConsent();
    }, []);

    return (
        <div className='mt-auto mb-0 fw-500'>
            <div>System Version 10.23.00</div>
            {t('sidebar:our_terms')} <br />
            <a href='/terms-conditions' className='text-white'>
                {t('sidebar:terms_and_conditions')}
            </a>
            <br />
            <a href='/privacy-policy' className='text-white'>
                {t('sidebar:privacy_policy')}
            </a>
            {theme.name !== 'mtl' && (
                <>
                    <Text className='mt-3'>สนใจร่วมเป็นส่วนหนึ่งกับเครือข่ายร้านยา PharmCare</Text>
                    <Text>สามารถเพิ่มเพื่อนและสอบถามรายละเอียดได้ที่</Text>
                    <Text>Line ID: @pharmcaresupport</Text>
                </>
            )}
            <InputToggle>
                <div>Cookie Consent</div>
                <div className='input-toggle'>
                    <input id={'toggle'} type='checkbox' checked={consent} onChange={(event) => onChange(event)} />
                    <label htmlFor={'toggle'} data-toggle={'cookieConsent'} aria-label='setCookie'>
                        <span className='toggle-text'>{consent ? 'On' : 'Off'}</span>
                    </label>
                </div>
            </InputToggle>
        </div>
    );
}
const Text = styled.div`
    label: footer-text;
    margin-bottom: 5px;
`;
const InputToggle = styled.div`
    label: input-toggle;

    display: flex;
    margin: 1rem 0;

    .input-toggle {
        margin-left: 0.5rem;
        .toggle-text {
            position: relative;
            z-index: 2;
        }
        input[type='checkbox'] {
            display: none;

            & + label {
                position: relative;
                width: 60px;
                height: 30px;
                border-radius: 30px;
                background-color: var(--lightseagreen-1);
                transition: background-color 0.3s;
                display: flex;
                align-items: center;
                /* justify-content: center; */
                cursor: pointer;
                padding-left: 8px;

                &::before {
                    content: '';
                    position: absolute;
                    display: block;
                    top: 4px;
                    left: 4px;
                    width: 22px;
                    height: 22px;
                    border-radius: 50%;
                    background-color: var(--white);
                    transition: transform 0.3s;
                }
            }

            &:checked + label:before {
                transform: translateX(30px);
            }

            &:not(:checked) + label {
                background-color: var(--text-normal-4);
                padding-left: 28px;
            }
        }
    }
`;
export default SidebarInfo;
